/*
 *
 * ManageVasPopup
 *
 * @version 1.0.0
 * @author Christopher Monti
 * @since 3-Mar-2025
 */

import ManageVasPopup from './ManageVasPopupContainer'

export default ManageVasPopup
